import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35355838"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-icons-list" }
const _hoisted_2 = {
  width: "20px",
  height: "20px",
  viewBox: "0 0 20 20",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "【2-ico】/3-应用/2-操作/1-增删改查/Btn2-删", -1))
const _hoisted_4 = {
  id: "【2-ico】/3-应用/2-操作/1-增删改查/Btn2-删",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}
const _hoisted_5 = ["fill"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M10.809375,10 L14.9109375,5.1109375 C14.9796875,5.0296875 14.921875,4.90625 14.815625,4.90625 L13.56875,4.90625 C13.4953125,4.90625 13.425,4.9390625 13.3765625,4.9953125 L9.99375,9.028125 L6.6109375,4.9953125 C6.5640625,4.9390625 6.49375,4.90625 6.41875,4.90625 L5.171875,4.90625 C5.065625,4.90625 5.0078125,5.0296875 5.0765625,5.1109375 L9.178125,10 L5.0765625,14.8890625 C5.0078125,14.9703125 5.065625,15.09375 5.171875,15.09375 L6.41875,15.09375 C6.4921875,15.09375 6.5625,15.0609375 6.6109375,15.0046875 L9.99375,10.971875 L13.3765625,15.0046875 C13.4234375,15.0609375 13.49375,15.09375 13.56875,15.09375 L14.815625,15.09375 C14.921875,15.09375 14.9796875,14.9703125 14.9109375,14.8890625 L10.809375,10 Z" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Icon, {
      style: _normalizeStyle(_ctx.style),
      class: "icon"
    }, {
      component: _withCtx(() => [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("g", _hoisted_4, [
            _createElementVNode("g", {
              id: "错",
              fill: _ctx.style.color
            }, _hoisted_7, 8, _hoisted_5)
          ])
        ]))
      ]),
      _: 1
    }, 8, ["style"])
  ]))
}